// components/ShowWrappedDialog.tsx
import { Cross2Icon } from '@radix-ui/react-icons';
import { Dialog } from '@radix-ui/themes';
import { pushEvent } from 'helpers/crmUtils';
import { useSmartAppDialog } from 'helpers/useSmartAppDialog';
import { ANDROID_APP_URL, IOS_APP_URL } from 'helpers/utils';
import '../../styles/wrapped.css';
import { TennistalkerIconFull } from './SocialIcons';

interface ShowWrappedDialogProps {
  isWrappedOpen: boolean;
  setIsWrappedOpen: (open: boolean) => void;
}

export const ShowWrappedDialog: React.FC<ShowWrappedDialogProps> = ({ isWrappedOpen, setIsWrappedOpen }) => {
  const { deviceInfo } = useSmartAppDialog();

  const IOS_DOWNLOAD_COMPONENT = (
    <a
      href={IOS_APP_URL}
      target='_blank'
      rel='noreferrer'
      onClick={() => pushEvent('TT - EVENT - Wrapped dialog download ios')}
    >
      <img src='/wrapped/download-appstore.png' alt='Download on the App Store' className='mx-auto w-28 sm:w-32' />
    </a>
  );

  const ANDROID_DOWNLOAD_COMPONENT = (
    <a
      href={ANDROID_APP_URL}
      target='_blank'
      rel='noreferrer'
      onClick={() => pushEvent('TT - EVENT - Wrapped dialog download android')}
    >
      <img src='/wrapped/download-playstore.png' alt='Download on the Play Store' className='mx-auto w-28 sm:w-32' />
    </a>
  );

  return (
    <Dialog.Root open={isWrappedOpen} onOpenChange={setIsWrappedOpen}>
      <Dialog.Title className='hidden'>Scarica l'app di Tennistalker</Dialog.Title>
      <Dialog.Description className='hidden'>
        Scarica l'app di Tennistalker per scoprire il tuo tennis wrapped.
      </Dialog.Description>
      <Dialog.Content className='relative mx-auto flex aspect-9/16 w-xs flex-col gap-6 bg-black bg-[url(/wrapped/bg-popup.jpg)] bg-cover p-0 font-[Inter] font-black sm:w-sm'>
        <Dialog.Close className='absolute top-4 right-4 cursor-pointer text-white'>
          <Cross2Icon height={'24'} width={'24'} />
        </Dialog.Close>
        <div className='flex grow' />

        <div className='mt-10 flex grow basis-0 flex-col items-center justify-center gap-1 text-center uppercase'>
          <div className='text-white'>Scarica l'app di</div>
          <div className='flex items-center justify-center text-black'>
            <TennistalkerIconFull className='bg-wrapped-accent w-10/12 px-6 py-1' />{' '}
          </div>
          <div className='flex flex-col items-center gap-0'>
            <div className='mt-2 text-sm text-white sm:text-base'>E scopri subito il tuo</div>
            <div className='text-2xl text-white italic sm:text-4xl'>TENNIS WRAPPED</div>
            <div className='bg-wrapped-accent mt-1 px-2 text-5xl text-black italic sm:text-7xl'>2025</div>
          </div>
        </div>

        <div className='flex grow flex-col items-center gap-3'>
          {deviceInfo ? (
            deviceInfo.os === 'ios' ? (
              IOS_DOWNLOAD_COMPONENT
            ) : (
              ANDROID_DOWNLOAD_COMPONENT
            )
          ) : (
            <>
              {IOS_DOWNLOAD_COMPONENT}
              {ANDROID_DOWNLOAD_COMPONENT}
            </>
          )}
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};
